import React from 'react';
import { graphql } from '../../generated';
import { t } from '../../locales/translate';
import { useRouterParam } from '../../model/history';
import { getPageTitle, useMeta } from '../../model/meta';
import { newsPath } from '../../routes';
import { useQueryHandler } from '../../model/graphql';
import { Container } from '../../components/Container/Container';
import { NewsItemCard } from './news_item_card';

const NEWS_ITEM = graphql(`
  query NewsItemQuery($id: ID!) {
    newsItem(id: $id) {
      id
      title
    }
  }
`);

export function NewsItem(): JSX.Element {
  const id = useRouterParam<{ id: string }>().id;
  const { data, loading } = useQueryHandler(NEWS_ITEM, { variables: { id } });
  const newsItem = data?.newsItem;

  useMeta({
    title: getPageTitle(loading, newsItem?.title || t.model.news.untitled, newsItem),
    breadcrumbs: [
      { title: t.model.news._plural, url: newsPath() },
      {
        title: getPageTitle(loading, newsItem?.title || t.model.news.untitled, newsItem),
      },
    ],
  });

  return (
    <Container>
      <NewsItemCard id={id} />
    </Container>
  );
}
